import{e as p,g as _,m as e}from"./chunk-HBP5N4FR.js";var n={};_(n,{css:()=>o,default:()=>s});var o,s,t=p(()=>{e();o=`.dapp-core-component__styles__address {
  display: flex;
  align-items: center;
}
.dapp-core-component__styles__address .dapp-core-component__styles__explorer {
  margin-left: 0;
  position: relative;
  display: flex;
  max-width: 100%;
  overflow: hidden;
  color: #1f43f4;
}
.dapp-core-component__styles__address .dapp-core-component__styles__explorer:hover {
  text-decoration: none;
}
.dapp-core-component__styles__address .dapp-core-component__styles__explorer span {
  max-width: none;
}
.dapp-core-component__styles__address .dapp-core-component__styles__explorer span [class*=left] span,
.dapp-core-component__styles__address .dapp-core-component__styles__explorer span [class*=right] span {
  font-size: 1rem;
  color: #1f43f4;
}
.dapp-core-component__styles__address .dapp-core-component__styles__explorer span:last-child {
  color: #1f43f4;
}

.dapp-core-component__styles__token {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
@media (min-width: 992px) {
  .dapp-core-component__styles__token.dapp-core-component__styles__spaced {
    margin-right: 0.25rem;
  }
}
.dapp-core-component__styles__token .dapp-core-component__styles__comma {
  display: none;
}
@media (min-width: 992px) {
  .dapp-core-component__styles__token .dapp-core-component__styles__comma {
    display: block;
  }
}`;document.head.appendChild(document.createElement("style")).appendChild(document.createTextNode(o));s={address:"dapp-core-component__styles__address",explorer:"dapp-core-component__styles__explorer",token:"dapp-core-component__styles__token",spaced:"dapp-core-component__styles__spaced",comma:"dapp-core-component__styles__comma"}});export{o as a,s as b,n as c,t as d};
//# sourceMappingURL=chunk-A7PSK6X4.js.map
